module.exports = __webpack_public_path__ + "static/img/left.0e7fc986.png";